import { createContext, useContext } from 'react';

// true for UI opened from the map (bottom-sheet card, pin drop dialog) —
// gates map-only components
export const MapEditContext = createContext(false);

export const useIsMapEdit = () => useContext(MapEditContext);
